import { render, staticRenderFns } from "./BindCar.vue?vue&type=template&id=db21884a&scoped=true&"
import script from "./BindCar.vue?vue&type=script&lang=js&"
export * from "./BindCar.vue?vue&type=script&lang=js&"
import style0 from "./BindCar.vue?vue&type=style&index=0&id=db21884a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db21884a",
  null
  
)

export default component.exports